<template>
  <app>
    <template v-slot:languageSelection>
      <language-selection />
    </template>
    <template v-slot:content>
      <router-view />
    </template>
  </app>
</template>

<script>
const App = () => import(/* webpackChunkName: "PortfolioPage" */ "@/App.vue");
const LanguageSelection = () =>
  import(/* webpackChunkName: "PortfolioPage" */ "@/components/Global/LanguageSelection.vue");

export default {
  name: "PortfolioApp",
  components: {
    App,
    LanguageSelection
  }
};
</script>
